<ng-container *ngIf="tableData">
    <div [ngClass]="{ 'card-panel': tableData.infoTableSectionTitle }">
        <div class="p-3" *ngIf="tableData.infoTableSectionTitle">
            <app-section-title
                [sectionTitleConfig]="tableData.infoTableSectionTitle"
            ></app-section-title>
        </div>
        <div
            *ngFor="let infoTableData of tableData.infoTableData"
            [ngClass]="{
                'pb-4 px-3 px-lg-5 ': tableData.infoTableSectionTitle
            }"
        >
            <h4>{{ infoTableData.cardHeader }}</h4>
            <div
                class="card-panel"
                [ngStyle]="{
                    'background-color':
                        tableData.infoTableBackground.backgroundColor
                }"
            >
                <div class="card-body">
                    <div
                        class="table-responsive"
                        *ngFor="
                            let header of infoTableData.headers;
                            let i = index
                        "
                    >
                        <table class="table table-striped info-table {{tableName}}">
                            <thead>
                                <tr>
                                    <th
                                        scope="col"
                                        *ngFor="
                                            let headerKey of header
                                                | keyvalue : originalOrder
                                        "
                                    >
                                        {{ headerKey.value }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    *ngFor="
                                        let rows of infoTableData.data;
                                        let j = index
                                    "
                                    [ngStyle]="{
                                        'background-color':
                                            tableData.infoTableBackground
                                                .rowColor
                                    }"
                                >
                                    <td
                                        *ngFor="
                                            let rowKey of infoTableData.data[j]
                                                | keyvalue : originalOrder;
                                            let last = last;
                                            let i = index
                                        "
                                    >
                                        <div
                                            class="fieldgroup"
                                            *ngIf="
                                                rowKey.value.type == 'inputtext'
                                            "
                                        >
                                            <mat-form-field [style.width.px]=115>
                                              <mat-label>{{
                                                  rowKey.value.placeholder
                                              }}</mat-label>
                                              <input
                                              matInput
                                              type="text"
                                              id="{{ rowKey.key }}{{ i }}"
                                              class=""
                                              value="{{ rowKey.value.value }}"
                                              name="{{ rowKey.key }}"
                                              placeholder=""
                                              (blur)="onBlurMethod($event, rowKey.value.value)"
                                              disabled="{{(rowKey.value['disabled']?rowKey.value.disabled:false)}}"
                                          />
                                            </mat-form-field>
                                        </div>
                                        <div class="row">
                                          <span class="error hidden">
                                            {{rowKey.value.error}}
                                          </span>
                                        </div>
                                        <div
                                            class="textgroup"
                                            *ngIf="rowKey.value.type == 'text'"
                                        >
                                        <input type="hidden" name="{{rowKey.key}}" value="{{rowKey.value.value}}">
                                            <span class="{{ rowKey.key }}">

                                              {{
                                                rowKey.value.value
                                            }}</span>
                                        </div>
                                        <div
                                            class="textgroup"
                                            *ngIf="rowKey.value.type == 'checkbox'"
                                        >
                                        <mat-checkbox name="{{rowKey.key}}" [checked]="rowKey.value.value" >
                                          <span [innerHTML]="rowKey.value.label"></span>
                                        </mat-checkbox>



                                        </div>
                                        <div
                                            class="textgroup double-fields"
                                            *ngIf="
                                                rowKey.value.type == 'double'
                                            "
                                        >


                                            <input

                                                type="text"
                                                class="form-control"
                                                value="{{rowKey?.value?.values[0]}}"
                                                name="ownership1"
                                                (blur)="onBlurMethod($event, rowKey?.value?.values[0])"/>
                                            /
                                            <input
                                                type="text"
                                                class="form-control"
                                                name="ownership2"
                                                value="{{rowKey?.value?.values[1]}}"
                                                (blur)="onBlurMethod($event, rowKey?.value?.values[1])"
                                            />
                                        </div>
                                        <div
                                            class="textgroup"
                                            *ngIf="
                                                rowKey.value.type == 'select'
                                            "
                                        >

                                            <select
                                                class="form-control form-control-sm"
                                                style="cursor: pointer"
                                                (change)="changeSelect($event)"
                                                name="{{ rowKey.key }}"
                                            >
                                                <option value=""></option>
                                                <option
                                                    *ngFor="
                                                        let items of rowKey
                                                            .value.values;
                                                            let k = index;
                                                    "
                                                    value="{{ items }}"

                                                >

                                                <ng-container *ngIf="tableName =='documentsTable'">
                                                  <p>
                                                    {{ items | documentsName}}

                                                </p>
                                                </ng-container>
                                                <ng-container *ngIf="tableName !=='documentsTable'">
                                                  <p>
                                                    {{ items }}
                                                </p>
                                                </ng-container>


                                                </option>
                                            </select>
                                        </div>

                                        <ng-container
                                            *ngIf="
                                                last &&
                                                infoTableData?.buttons?.addRow
                                            "
                                            ><i
                                                class="material-icons align-middle remove-btn"
                                                (click)="removeRow(i)"
                                                >delete</i
                                            ></ng-container
                                        >
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="text-right" *ngIf="infoTableData.buttons">
                        <button
                            class="btn btn-secondary app-button"
                            (click)="addRow()"
                            *ngIf="infoTableData.buttons.addRow"
                        >
                            {{ infoTableData.buttons.addRow.name }}
                        </button>

                        <button
                            class="btn btn-secondary app-button"
                            (click)="submit()"
                            *ngIf="infoTableData.buttons.submit"
                        >
                            {{ infoTableData.buttons.submit.name }}
                        </button>
                        <button
                        class="btn btn-secondary app-button"
                        (click)="getChargesFromFormValues(infoTableData.cadID, $event)"
                        *ngIf="infoTableData.buttons.calculateCharges"
                    >
                        {{ infoTableData.buttons.calculateCharges.name }}
                    </button>
                    </div>

                    <div class="row" *ngIf="tableName === 'documentsTable'">
                      <ng-container>
                          <div class="col-12">
                            <div class="col-12 col-lg-12">
                              <app-success-message [MessageTitle]="">
                                <span class="qrcode-value"
                                  >
                                  <br />
                                  Σε περίπτωση που έχετε χρησιμοποιήσει Τοπογραφικό Διάγραμμα που
                                  <b>δε φέρει Κωδικό Ηλεκτρονικού Διαγράμματος (Κ.Η.Δ.)</b>
                                  παρακαλείστε όπως <b>μεταφορτώσετε Τοπογραφικό Διάγραμμα</b>.
                                  <br />
                                  <br />
                                  Η ενότητα Συνοδευτικά Έγγραφα είναι προαιρετική και συμπληρώνεται μόνο
                                  στην περίπτωση που είτε ο Κωδικός Ηλεκτρονικού Διαγράμματος (Κ.Η.Δ.)
                                  είτε το Τοπογραφικό Διάγραμμα είναι απαραίητα για τη διεκπεραίωση της
                                  τρέχουσας πράξης μεταβίβασης.
                                  <br />
                                  <br />
                                </span>
                              </app-success-message>
                            </div>
                          </div>
                      </ng-container>
                    </div>

                </div>
            </div>
        </div>
    </div>
</ng-container>
